/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ERepairshopOnline = 'Online' | 'Offline';

export const ERepairshopOnline = {
    Online: 'Online' as ERepairshopOnline,
    Offline: 'Offline' as ERepairshopOnline
};

